import Spinner from '../../Spinner';
import {withIntl} from "../../Intl";
import {FormattedMessage} from 'react-intl';
import Messages from './Bottom.messages';

class Bottom extends React.Component {
    error() {
        if (this.props.status === 'error') {
            return <div className="form-control-feedback small text-danger mt-2">
                <FormattedMessage {...Messages.failed_to_signup}/>
            </div>
        }
    }

    success() {
        if (this.props.status === 'success') {
            return <div className="form-control-feedback small text-success mt-2">
                <FormattedMessage {...Messages.signup_success}/>
            </div>
        }
    }

    buttonText() {
        if (this.props.status === 'loading') {
            return <Spinner/>
        }

        return <FormattedMessage {...Messages.signup_cta}/>;
    }

    form() {
        const {intl} = this.props;

        return <form className="col-12 col-md-10 col-lg-8 col-xl-6 m-auto" onSubmit={this.props.onSubmit}>
            <div className="input-group">
                <input
                    className="small form-control"
                    placeholder={intl.formatMessage(Messages.type_your_email)}
                    type="email"
                    name="email"
                    required="required"
                    onChange={this.props.setEmail}
                    value={this.props.email}/>
                <span className="input-group-btn">
                    <button type="submit"
                            className={"btn btn-primary" + ((this.props.status === 'loading') ? " disabled" : "")}
                            style={{width: '100px'}}>
                        <small>{this.buttonText()}</small>
                    </button>
                </span>
            </div>
            {this.error()}
            {this.success()}
        </form>
    };

    render() {
        if (this.props.sessionEmail && this.props.status !== 'success') {
            return <div />
        }

        return <div>
            <div className="container-fluid p-0 bg-light-gray">
                <div className="container p-sm-0">
                    <div className="row">
                        <div className="col-12 text-center px-0 py-4 p-md-5">
                            <h4 className="text-blue h5"><FormattedMessage {...Messages.title}/></h4>
                            <p><FormattedMessage {...Messages.subtitle}/></p>
                            {this.form()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default withIntl(Bottom);
